const errorMessageDefault = 'Ошибка'

/**
 * Бизнес-ошибка, поднятая при HTTP 200 + { success: false }.
 *
 * Axios не считает такой ответ ошибкой — без этого класса фронтенд
 * молча «проглатывал» отказ бэкенда и показывал «Успешно».
 */
export class ApiBusinessError extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'ApiBusinessError'
    }
}

/**
 * Успешен ли ответ API: бэкенд отдаёт { success: false } при бизнес-отказе
 * даже с HTTP 200 (дубликаты, «уже добавлено» и т.п.).
 */
export const isApiSuccess = (response: any): boolean => response?.data?.success !== false

/**
 * Возвращает сообщение бизнес-ошибки при { success: false }, иначе null.
 */
export const getApiBusinessError = (response: any): string | null => {
    if (response?.data?.success === false) {
        return response.data.message || errorMessageDefault
    }

    return null
}

/**
 * Сообщение из data (для показа в уведомлениях).
 */
export const extractApiError = (response: any): string => response?.data?.message || ''

export const getResponseErrorMessage = (err:any, errorDefault?:string) => {
    const responseMessage = err?.response?.data?.message;

    if(responseMessage) {
        return responseMessage
    }

    // Бизнес-отказ с HTTP 200 (success: false) — сообщение без response
    if(err instanceof ApiBusinessError) {
        return err.message
    }

    if(errorDefault) {
        return errorDefault
    }

    return errorMessageDefault
}
